// Redirect slashless paths before S3/CloudFront can leak the deploy commit hash.
const { pathname, search, hash } = window.location
const segment = pathname.split('/').pop() || ''

if (pathname !== '/' && !pathname.endsWith('/') && !segment.includes('.')) {
  window.location.replace(`${pathname}/${search}${hash}`)
}
